'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = values;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _firekit2 = require('@upgrowth/firekit');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function values(BoundComponent) {
  return function (_React$Component) {
    (0, _inherits3.default)(_class2, _React$Component);

    function _class2() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class2.__proto__ || (0, _getPrototypeOf2.default)(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        values: {}
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(_class2, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.initFetch(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(props) {
        this.initFetch(props);
      }
    }, {
      key: 'initFetch',
      value: function initFetch(props) {
        var _this2 = this;

        var context = props.context,
            snapshot = props.snapshot,
            values = props.type.values;
        var firelight = context.firelight;

        var _firekit = (0, _firekit2.firekit)(),
            database = _firekit.database;

        if (typeof values === "string") {
          var location = values;

          if (location !== this.location) {
            this.location = location;

            if (location.startsWith('/')) {
              database.ref('' + firelight + location).once('value').then(function (snapshot) {
                return snapshot.val();
              }).then(function (values) {
                return _this2.setState({
                  values: values
                });
              });
            } else {
              var snapshotValue = (0, _lodash.get)(snapshot, location.split('/'), {});
              this.setState({
                values: snapshotValue
              });
            }

            this.location = location;
          }
        } else {
          this.setState({
            values: values || {}
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(BoundComponent, (0, _extends3.default)({}, this.props, {
          values: this.state.values
        }));
      }
    }]);
    return _class2;
  }(_react2.default.Component);
}